import { PricingUtilsDiscount, PricingUtilsMinimum } from '@sequencehq/utils'
import {
  Phase,
  PhaseDiscount,
  Price
} from '../../atoms/reviewPricing.primitives.atoms'
import { getPricesForPhase } from '../../utils/phases'

export const pricingUtilsPhaseAdapter = {
  in: ({ phase, prices }: { phase: Phase; prices: Price[] }) => ({
    ...phase,
    prices: getPricesForPhase({ phase, prices }),
    discounts: phase.discounts.map(pricingUtilsDiscountAdapter.in),
    minimums: phase.minimums.map(pricingUtilsMinimumAdapter.in),
    // Contract review pricing does not edit credit grants.
    creditGrants: undefined
  })
}

export const pricingUtilsDiscountAdapter = {
  in: (discount: PhaseDiscount): PricingUtilsDiscount => {
    return {
      ...discount,
      discountCalculationType: discount.type,
      priceIds: discount.restrictToPrices,
      applyToAllPrices: discount.restrictToPrices.length === 0
    }
  },
  out: (
    discount: PricingUtilsDiscount,
    boundingBoxIndex: number
  ): PhaseDiscount => {
    return {
      ...discount,
      restrictToPrices: discount.priceIds,
      type: discount.discountCalculationType,
      boundingBoxIndex
    }
  }
}

export const pricingUtilsMinimumAdapter = {
  in: (minimum: Phase['minimums'][0]) => {
    return {
      ...minimum,
      name: '',
      value: `${minimum.amount}`,
      scope: {
        target:
          minimum.restrictToPrices.length === 0
            ? ('allUsage' as const)
            : ('specific' as const),
        priceIds: minimum.restrictToPrices
      }
    }
  },
  out: (minimum: PricingUtilsMinimum): Phase['minimums'][0] => {
    return {
      ...minimum,
      restrictToPrices: minimum.scope.priceIds,
      amount: Number(minimum.value)
    }
  }
}
